import BioElements from './BioElements';
import ActivityElements from './ActivityElements';
import StakeholderPageSkeleton from './StakeholderPageSkeleton';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import { useContext, useEffect, useRef, useState } from 'react';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import MobileUI from './MobileUI';
import { useAuth0 } from '@auth0/auth0-react';
import CreateAccountPopup from 'components/Dashboard/components/CreateAccountPopup';
import NoEnableUsersPopup from './NoEnableUsersPopup';
import StakeholderCrmPopup from './StakeholderCrmPopup';
import InfluenceNotIncludedFeaturesPopup from 'components/Dashboard/Influence/CrmContacts/InfluenceNotIncludedFeaturesPopup';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import { store } from 'components/Store';
import EmployersElement from 'components/Dashboard/StakeHolders/StakeholderPage/ui/EmployersElement';
import { useParams } from 'react-router';

const Stakeholder = (props) => {
  const {
    isBioLoading,
    isInitialActivityLoading,
    load_more_results,
    activityContainer,
    stakeholderSearchCondition,
    StakeholderInformation,
    contentRelated,
    isLoadingActivity,
    searchPageQuery,
    localTopic,
    setLocalTopic,
    seeAllActivity,
    setClickOnSeeMore,
    keywordsLists,
  } = props;
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const { showStakeholderCrmPopup, showContactsPopup, selectedUpdates } = state;
  const { isStaff, employers } = StakeholderInformation;

  const [activeTab, setActiveTab] = useState('Profile');
  const [heightContainer, containerRef] = useHeightContainer();
  const [showPopup, setShowPopup] = useState(false);
  const [contentScrolled, setContentScrolled] = useState(false);
  const [bioElementsScrollBarPosition, setBioElementsScrollBarPosition] = useState(0);
  const [isTopicPickerOpen, setIsTopicPickerOpen] = useState(false);

  const params = useParams();
  const { id } = params;
  const isRightSideLoading = isInitialActivityLoading || isLoadingActivity;

  const scrollElement = useRef(null);
  const bioSectionContainer = useRef(null);
  const BioContent = useRef(null);
  const ActivityContent = useRef(null);

  const activityProps = {
    stakeholderSearchCondition,
    StakeholderInformation,
    contentRelated,
    isLoadingActivity: isLoadingActivity || isInitialActivityLoading,
    searchPageQuery,
    localTopic,
    setLocalTopic,
    seeAllActivity,
    setClickOnSeeMore,
    keywordsLists,
    onTopicPickerStateChange: setIsTopicPickerOpen,
  };

  const setShowStakeholderCrmPopup = (val) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'showStakeholderCrmPopup',
      value: val,
    });
  };

  const setShowContactsPopup = (val) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'showContactsPopup',
      value: val,
    });
  };

  const setShowContactsPopupHandler = (val) => {
    if (!!val?.url) {
      setShowContactsPopup({ show: val?.show, url: val?.url });
    } else {
      setShowContactsPopup({ show: val });
    }
  };

  const isMobile = useIsMobile();
  const { isAuthenticated } = useAuth0();

  const ScrollContent = (scrollValues) => {
    const { scrollTop, scrollHeight, clientHeight } = scrollValues;
    setContentScrolled(scrollTop > 0);
    const checkMoreResults = () => {
      const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
      if (scrolledToBottom) {
        load_more_results();
      }
    };
    checkMoreResults();
  };

  useEffect(() => {
    setActiveTab('Profile');
    setBioElementsScrollBarPosition(0);
  }, [id]);

  return (
    <div className={`pt-lg-4 px-lg-5 h-100`}>
      {isBioLoading && <StakeholderPageSkeleton />}
      {!isBioLoading && (
        <>
          {isMobile && (
            <>
              <div ref={containerRef} />
              <MobileUI
                {...props}
                setShowPopup={setShowPopup}
                ScrollContent={ScrollContent}
                setShowContactsPopup={setShowContactsPopupHandler}
                setShowStakeholderCrmPopup={setShowStakeholderCrmPopup}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                heightContainer={heightContainer}
              />
            </>
          )}
          {!isMobile && (
            <div
              ref={scrollElement}
              className={`stakeholder-wrapper-container ${selectedUpdates?.length > 0 ? 'move' : ''}`}
            >
              <div className='d-lg-flex'>
                <div ref={containerRef} className={`biography-general-container ${isStaff ? 'staff' : ''}`}>
                  <CustomScrollbar
                    className={'simple-scrollbar profile-scrollbar'}
                    style={{ height: `${heightContainer - (selectedUpdates?.length > 0 ? 56 : 0)}px` }}
                    maximalThumbYSize={100}
                    onScroll={(scrollValues) => {
                      const { scrollTop } = scrollValues;
                      setBioElementsScrollBarPosition(scrollTop);
                    }}
                    ref={bioSectionContainer}
                  >
                    <div className='pr-4'>
                      <BioElements
                        {...props}
                        ref={BioContent}
                        setShowContactsPopup={setShowContactsPopupHandler}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        setShowStakeholderCrmPopup={setShowStakeholderCrmPopup}
                        bioElementsScrollBarPosition={bioElementsScrollBarPosition}
                        bioSectionContainer={bioSectionContainer}
                      />
                    </div>
                  </CustomScrollbar>
                </div>
                <div className='flex-grow-1'>
                  <CustomScrollbar
                    className={`main-content-scrollbar top-content-scrollbar ${isTopicPickerOpen ? 'scrollbar-disabled' : ''}`}
                    style={{ height: `${heightContainer}px` }}
                    maximalThumbYSize={100}
                    onScroll={(scrollValues) => {
                      ScrollContent(scrollValues);
                    }}
                    ref={activityContainer}
                  >
                    {isStaff ? (
                      <EmployersElement employers={employers} activityContainer={activityContainer} />
                    ) : (
                      <ActivityElements
                        {...activityProps}
                        scrollBarRef={activityContainer}
                        ref={ActivityContent}
                        contentScrolled={contentScrolled}
                        setShowPopup={setShowPopup}
                        isRightSideLoading={isRightSideLoading}
                      />
                    )}
                  </CustomScrollbar>
                </div>
              </div>
            </div>
          )}
          <NoEnableUsersPopup setShowPopup={setShowPopup} showPopUp={isAuthenticated && showPopup} />
          {!isAuthenticated && (
            <CreateAccountPopup
              text={'You’ll need to create an account to do that search'}
              setShowPopup={setShowPopup}
              showPopup={showPopup}
            />
          )}
          <StakeholderCrmPopup
            setShowPopup={setShowContactsPopupHandler}
            showPopUp={showContactsPopup.show}
            showContactsPopup={showContactsPopup}
          />
          <InfluenceNotIncludedFeaturesPopup
            showPopup={showStakeholderCrmPopup}
            type={'contacts'}
            setShowPopup={setShowStakeholderCrmPopup}
          />
        </>
      )}
    </div>
  );
};

export default Stakeholder;
